import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import Loader from 'react-overlay-loader/lib/Loader';
import { DepositFilterTypes } from '../../../../../../utils/constants/deposits';
import '../index.scss';
import BookingsTableHead from './BookingsTableHead';
import BookingsTableRow from './BookingsTableRow';

class BookingsTable extends React.Component {
  render() {
    const {
      venue,
      bookingList,
      reservationDate,
      showBookingModal,
      showBookingDetailsModal,
      loading,
      filterType,
      searchResults,
      searchValue,
    } = this.props;
    let filteredBookingList = bookingList;

    if (searchResults && searchResults.length > 0 && searchValue) {
      filteredBookingList = searchResults;
      // Apply filters even if search results are present to show confirmed/pending deposits
      if (filterType === DepositFilterTypes.CONFIRMED_DEPOSITS) {
        filteredBookingList = filteredBookingList.filter(
          booking => booking.paid_at !== null
        );
      } else if (filterType === DepositFilterTypes.PENDING_DEPOSITS) {
        filteredBookingList = filteredBookingList.filter(
          booking => booking.paid_at === null
        );
      }
    } else {
      if (searchResults.length === 0 && searchValue) {
        return (
          <div>
            <Table>
              <BookingsTableHead venue={venue} />
              <TableBody />
            </Table>
            <div
              style={{
                padding: '5px',
              }}
            >
              <p style={{ textAlign: 'center' }}>No deposits found.</p>
              <Loader loading={loading} />
            </div>
          </div>
        );
      }
      if (filterType === DepositFilterTypes.CONFIRMED_DEPOSITS) {
        filteredBookingList = bookingList.filter(
          booking => booking.paid_at !== null
        );
      } else if (filterType === DepositFilterTypes.PENDING_DEPOSITS) {
        filteredBookingList = bookingList.filter(
          booking => booking.paid_at === null
        );
      }
    }

    if (reservationDate) {
      const filterDate = new Date(reservationDate);
      filteredBookingList = filteredBookingList.filter(booking => {
        const bookingDate = new Date(booking.reserved_from);
        return bookingDate.getTime() > filterDate.getTime();
      });
    }

    return (
      <div>
        <Table>
          <BookingsTableHead venue={venue} />

          <TableBody>
            {filteredBookingList.map(booking => {
              const boundBookingModal = showBookingModal.bind(this, booking);
              return (
                <BookingsTableRow
                  showBookingDetailsModal={showBookingDetailsModal}
                  onClick={boundBookingModal}
                  key={booking.id}
                  venue={venue}
                  booking={booking}
                />
              );
            })}
          </TableBody>
        </Table>
        {filteredBookingList.length === 0 && (
          <div
            style={{
              padding: '5px',
            }}
          >
            <p style={{ textAlign: 'center' }}>
              You have no reservations for{' '}
              {moment(reservationDate).format('MMMM Do')},{' '}
              {moment(reservationDate).utc().format('dddd')}.
            </p>
          </div>
        )}
        <Loader loading={loading} />
      </div>
    );
  }
}

BookingsTable.propTypes = {
  showBookingModal: PropTypes.func.isRequired,
  venue: PropTypes.object.isRequired,
  bookingList: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  showBookingDetailsModal: PropTypes.func.isRequired,
  filterType: PropTypes.oneOf(Object.values(DepositFilterTypes)).isRequired,
  reservationDate: PropTypes.string,
  searchResults: PropTypes.array,
  searchValue: PropTypes.string,
};

export default BookingsTable;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Bookings/ViewBookingsPanel/BookingsTable/index.jsx